var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCaminar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10765",
    "data-name": "Group 10765",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.095,
    height: 34.895,
    viewBox: "0 0 18.095 34.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6918",
    "data-name": "Path 6918",
    d: "M89.959,319.6a1.879,1.879,0,1,1-3.521-1.311l2.456-6.551a1.872,1.872,0,0,1,.965-1.046L96,307.83a1.881,1.881,0,0,1,2.559,2.349l-2.084,5.633,4.321,3.271a1.883,1.883,0,0,1-2.269,3.006L95.111,319.5l-.223.6,4.47,4.47a1.878,1.878,0,0,1,.548,1.206l.954,8.162a1.884,1.884,0,0,1-3.743.428l-.887-7.589-2.509-2.509-.83,3.321a1.875,1.875,0,0,1-.505.885l-5.676,6.082A1.882,1.882,0,0,1,83.955,332l5.4-5.786,1.494-5.979a1.863,1.863,0,0,1,.124-.4l2.466-6.659-1.295.6-2.185,5.829Z",
    transform: "translate(-83.451 -301.146)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6919",
    "data-name": "Path 6919",
    d: "M203.045,244.98a2.965,2.965,0,1,1-2.965,2.964A2.964,2.964,0,0,1,203.045,244.98Z",
    transform: "translate(-187.98 -244.98)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCaminar);
export default __webpack_public_path__ + "static/media/ICO-CAMINAR.976ad594d7c48c8282b3eca50eb24894.svg";
export { ForwardRef as ReactComponent };